export class DadosPesquisaEntidade {
    public Nome: string;
    public Cpf: string;
}
